import * as React from "react";
import {Redirect, RouteComponentProps, Switch} from "react-router";
import SiteList from "../components/site/SiteList";
import RestrictedRoute from "./route/RestrictedRoute";
import {UserPermission} from "../model/user/UserPermission";

/**
 * Site router view.
 */
export default class SiteRouter extends React.PureComponent <RouteComponentProps<{}>, {}> {

	render() {
		return (
			<Switch>
				<RestrictedRoute exact
								 path={this.props.match.url}
								 component={SiteList}
								 allowedPermissions={[UserPermission.SiteView]}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		);
	}
}
